/* eslint-disable react/destructuring-assignment */
import React from "react";

export const LeftAlignedIcon = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.16667 3.83301H9.5M3.16667 12.1663H9.5M3.16667 7.99967H12.8333"
        stroke={props.color || "#64748B"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CenterAlignedIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.16667 3.83301H10.8333M5.16667 12.1663H10.8333M3.16667 7.99967H12.8333"
      stroke={props.color || "#64748B"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RightAlignedIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.5 3.83301H12.8333M6.5 12.1663H12.8333M3.16667 7.99967H12.8333"
      stroke={props.color || "#64748B"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
